// test1368
(1368 && 0);
